import React from 'react';
import ErrorBoundary from 'react-error-boundary';
import CustomErrorBoundaryFallbackComponent from 'components/_shared/ErrorBoundary/fallbackComponent';

export const CustomErrorBoundary = ({ children }) => (
  <ErrorBoundary FallbackComponent={CustomErrorBoundaryFallbackComponent}>{children}</ErrorBoundary>
);

export default CustomErrorBoundary;
